var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgCheckGreenIcon = function SvgCheckGreenIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#22C58B"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.598 23.736l-4.893-4.863a.714.714 0 01-.205-.527c0-.215.068-.39.205-.527l1.084-1.055a.653.653 0 01.513-.235c.205 0 .386.079.542.235l3.281 3.281 7.031-7.031a.744.744 0 01.542-.235c.205 0 .376.079.513.235l1.084 1.055a.714.714 0 01.205.527c0 .215-.068.39-.205.527l-8.643 8.613a.669.669 0 01-.527.235.669.669 0 01-.527-.235z"
  }))));
};
export default SvgCheckGreenIcon;